module.exports = __webpack_public_path__ + "static/media/direct-audience-left.5f9d273a.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/AttachProductComponents/direct-audience-left.png
// module id = 379
// module chunks = 0